module.exports = __webpack_public_path__ + "img/zfb.67b030e0.png";